import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-wrapper',
  template: `
    <ng-container *ngIf="activityToken; else defaultView">
      <app-activity-page></app-activity-page>
    </ng-container>
    <ng-template #defaultView>
      <app-resultpage></app-resultpage>
    </ng-template>
  `,
})
export class AppWrapperComponent implements OnInit {
  activityToken: boolean = false;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    this.activityToken = !!urlParams.get('activityToken');
  }

}
